import { LatLng, latLngBounds } from "leaflet";

let LZString = require("lz-string");
let parser = require("fast-xml-parser");
let he = require("he");

export class Path {
  constructor(file, name, pts) {
    this.name = name;
    this.points = pts || [];
    this.file = file;
  }

  update() {
    return Object.freeze(new Path(this.file, this.name, this.points));
  }

  lengthkm() {
    let l = 0;
    for (let i = 0; i < this.points.length - 1; ++i) {
      l += this.points[i].distanceTo(this.points[i + 1]);
    }
    return l / 1000.0;
  }

  lengthto(pt) {
    let l = 0;
    for (let i = 0; i < pt; ++i) {
      l += this.points[i].distanceTo(this.points[i + 1]);
    }
    return l / 1000.0;
  }

  length() {
    return this.lengthkm() / 1.60934;
  }

  bounds() {
    return latLngBounds(this.points);
  }

  nearest(point) {
    let minDist = 1e10;
    let minIx = -1;
    for (let i = 0; i < this.points.length; ++i) {
      let dist = this.points[i].distanceTo(point);
      if (dist < minDist) {
        minDist = dist;
        minIx = i;
      }
    }
    return { dist: minDist, minIx: minIx, point: this.points[minIx] };
  }

  allNearest(point) {
    let minDist = -1;
    let minIx = -1;
    let res = [];
    for (let i = 0; i < this.points.length; ++i) {
      let dist = this.points[i].distanceTo(point);
      if (dist < 100 && (dist < minDist || minIx === -1)) {
        minDist = dist;
        minIx = i;
      }
      if (dist > 1000 && minIx !== -1) {
        res.push({ dist: minDist, minIx: minIx, point: this.points[minIx] });
        minIx = -1;
        minDist = -1;
      }
    }
    if (minIx >= 0) {
      res.push({ dist: minDist, minIx: minIx, point: this.points[minIx] });
    }
    return res;
  }

  gain() {
    let bfele = [];
    for (let i = 0; i < this.points.length; ++i) {
      let e = 0;
      for (let j = -2; j <= 2; ++j) {
        if (i + j >= 0) {
          if (i + j < this.points.length) {
            e += this.points[i + j].alt;
          } else {
            e += this.points[this.points.length - 1].alt;
          }
        } else {
          e += this.points[0].alt;
        }
      }
      bfele.push(e / 5);
    }
    let l = 0;
    let s = bfele[0];
    let sp = s;
    for (let i = 1; i < this.points.length; ++i) {
      s = bfele[i];
      if (s > sp) {
        l += s - sp;
      }
      sp = s;
    }
    return l * 3.28084;
  }

  start() {
    return this.points[0];
  }

  end() {
    return this.points[this.points.length - 1];
  }

  reverse() {
    this.points.reverse();
  }

  split(index) {
    let other = this.points.slice(index, this.points.length);
    this.points.splice(index, this.points.length - index);
    return new Path(this.file, this.name, other);
  }

  _findClosestShortest(point, fromIndex, direction, id) {
    let minDist = 100000;
    let minIndex = -1;
    let distanceOfMin = -1;
    let distance = 0;
    for (
      let i = fromIndex + direction;
      i < this.points.length && i >= 0;
      i += direction
    ) {
      distance += this.points[i - direction].distanceTo(this.points[i]);
      let dist = this.points[i].distanceTo(point);
      if (dist < minDist) {
        minDist = dist;
        minIndex = i;
        distanceOfMin = distance;
      }
    }
    return {
      minDist: minDist,
      minIndex: minIndex,
      distOfMin: distanceOfMin,
      pointid: id,
      path: this,
      pathix: fromIndex,
    };
  }

  findClosestShortest(points, fromIndex) {
    if (!points || points.length === 0) {
      return [];
    }
    return [
      //this._findClosestShortest(points[0], fromIndex, 1, 0),
      //this._findClosestShortest(points[0], fromIndex, -1, 0),
      this._findClosestShortest(points[points.length - 1], fromIndex, 1, 1),
      this._findClosestShortest(points[points.length - 1], fromIndex, -1, 1),
    ];
  }

  join(otherPath) {
    if (!(otherPath instanceof Path)) {
      throw new Error("Wrong join arg");
    }

    if (this.points.length === 0) {
      return otherPath;
    }
    if (otherPath.points.length === 0) {
      return this;
    }
    let d0 = this.end.distanceTo(otherPath.start);
    let d1 = this.end.distanceTo(otherPath.end);
    let d2 = this.start.distanceTo(otherPath.end);
    let d3 = this.start.distanceTo(otherPath.start);
    let dmin = Math.min(d0, d1, d2, d3);
    if (d0 === dmin) {
      this.points.concat(otherPath.points);
    } else if (d1 === dmin) {
      this.points.concat(otherPath.points.reverse());
    } else if (d2 === dmin) {
      let newpath = [];
      newpath.concat(otherPath.points);
      newpath.concat(this.points);
      this.points = newpath;
    } else {
      let newpath = [];
      newpath.concat(otherPath.points.reverse());
      newpath.concat(this.points);
      this.points = newpath;
    }
  }

  copy() {
    let newpath = [];
    newpath.concat(this.points);
    return new Path(this.file, this.name, newpath);
  }

  elebounds() {
    let minele = 100000;
    let maxele = -10000;
    for (let i = 0; i < this.points.length; ++i) {
      if (this.points[i].alt > maxele) {
        maxele = this.points[i].alt;
      }
      if (this.points[i].alt < minele) {
        minele = this.points[i].alt;
      }
    }
    return [0, this.lengthkm(), minele, maxele];
  }

  jointime() {
    if (!this.points[0].ts) {
      return;
    }
    let last = this.points[0].ts;
    let lastAct = last;
    for (let i = 1; i < this.points.length; i++) {
      let delta = this.points[i].ts - lastAct;
      if (Math.abs(delta) < 600) {
        if (delta < 0) {
          last -= delta;
        } else {
          last += delta;
        }
      } else {
        last += 3;
      }
      lastAct = this.points[i].ts;
      this.points[i] = this.points[i].clone();
      this.points[i].ts = last;
    }
  }

  adjusttime(start, end) {
    let actstart = this.points[0].ts;
    let actend = this.points[this.points.length - 1].ts;
    let factor = (end - start) / (actend - actstart);
    for (let i = 0; i < this.points.length; i++) {
      let nts = (this.points[i].ts - actstart) * factor + start;
      this.points[i] = this.points[i].clone();
      this.points[i].ts = nts;
    }
  }

  randn_bm() {
    let u = 0,
      v = 0;
    while (u === 0) u = Math.random(); //Converting [0,1) to (0,1)
    while (v === 0) v = Math.random();
    let num = Math.sqrt(-2.0 * Math.log(u)) * Math.cos(2.0 * Math.PI * v);
    num = num / 10.0 + 0.5; // Translate to 0 -> 1
    if (num > 1 || num < 0) return this.randn_bm(); // resample between 0 and 1
    return num;
  }

  fuzz() {
    for (let i = 0; i < this.points.length; i++) {
      let dlat = (this.randn_bm() - 0.5) * 0.000001;
      let dlon = (this.randn_bm() - 0.5) * 0.000001;
      let old = this.points[i];
      this.points[i] = new LatLng(old.lat + dlat, old.lng + dlon, old.alt);
      this.points[i].ts = old.ts;
    }
  }

  realify(start, end) {
    this.jointime();
    this.adjusttime(start, end);
    this.fuzz();
  }

  simplify(toleranceMtr) {
    let earth = 40075000.0; // average circumference in metres at sea level
    let tolerance = (toleranceMtr * 360.0) / earth;
    let sqTol = tolerance * tolerance;
    this.dp(this.points, 0, this.points.length - 1, sqTol);
  }

  dp(points, from, top, sqTol) {
    let maxsq = 0;
    let index = from;
    for (let i = from + 1; i < top; ++i) {
      let distsq = this.distanceSq(points[from], points[top], points[i]);
      if (distsq > maxsq) {
        maxsq = distsq;
        index = i;
      }
    }
    if (maxsq > sqTol) {
      let shift1 = this.dp(points, from, index, sqTol);
      let shift2 = this.dp(points, index - shift1, top - shift1, sqTol);
      return shift1 + shift2;
    } else {
      if (top - from > 1) {
        points.splice(from + 1, top - from - 1);
        return top - from - 1;
      }
      return 0;
    }
  }

  distanceSq(p1, p2, p) {
    let x = p1.lat,
      y = p1.lng,
      dx = p2.lat - x,
      dy = p2.lng - y,
      dot = dx * dx + dy * dy,
      t;

    if (dot > 0) {
      t = ((p.lat - x) * dx + (p.lng - y) * dy) / dot;

      if (t > 1) {
        x = p2.lat;
        y = p2.lng;
      } else if (t > 0) {
        x += dx * t;
        y += dy * t;
      }
    }

    dx = p.lat - x;
    dy = p.lng - y;

    return dx * dx + dy * dy;
  }

  serialize() {
    let res = "<trkseg>";
    for (let p of this.points) {
      let al = "";
      let ts = "";
      if (p.ts) {
        ts = `<time>${new Date(p.ts * 1000)
          .toISOString()
          .replace(".000Z", "Z")}</time>`;
      }
      if (p.alt) {
        al = `<ele>${p.alt}</ele>`;
      }
      res += `<trkpt lat="${p.lat}" lon="${p.lng}">${al}${ts}</trkpt>`;
    }
    return res + "</trkseg>";
  }
}

let colors = ["red", "blue", "magenta", "cyan", "green", "orange"];
let colorIndex = 0;

export class GpxFile {
  constructor(metadata, points, waypoints) {
    this.file = metadata.file;
    this.name = metadata.name;
    if (points) {
      this.paths = [Object.freeze(new Path(this.file, this.name, [...points]))];
    } else {
      this.paths = [];
    }
    if (waypoints) {
      this.waypoints = [...waypoints];
    } else {
      this.waypoints = [];
    }
    if (metadata.color) {
      this.color = metadata.color;
    } else {
      this.color = colors[colorIndex % colors.length];
      colorIndex += 1;
    }
    this.opacity = metadata.opacity || 1;
    this.handle = metadata.handle || `f_${new Date().getMilliseconds()}`;
  }

  addWaypoint(p) {
    let wp = new LatLng(p.lat, p.lng);
    wp.name = "Waypoint";
    wp.description = "";
    this.waypoints.push(wp);
  }

  deleteWaypoint(ix) {
    this.waypoints.splice(ix, 1);
  }

  bounds() {
    if (!this.paths) {
      return null;
    }
    let bounds = this.paths[0].bounds();
    for (let i = 1; i < this.paths.length; ++i) {
      bounds.extend(this.paths[i].bounds());
    }
    return bounds;
  }

  cycle_opacity() {
    if (this.opacity > 0.5) {
      this.opacity = 0.45;
    } else if (this.opacity < 0.5 && this.opacity > 0) {
      this.opacity = 0;
    } else {
      this.opacity = 1;
    }
  }

  opacity_icon() {
    if (this.opacity > 0.5) {
      return "mdi-eye";
    } else if (this.opacity < 0.5 && this.opacity > 0) {
      return "mdi-eye-outline";
    } else {
      return "mdi-eye-off";
    }
  }

  metadata() {
    return {
      file: this.file,
      name: this.name,
      color: this.color,
      opacity: this.opacity,
      handle: this.handle,
    };
  }

  get length() {
    let dist = 0;
    for (let p of this.paths) {
      dist += p.length();
    }
    return dist;
  }

  get size() {
    let sz = 0;
    for (let p of this.paths) {
      sz += p.points.length;
    }
    return sz;
  }

  get tracks() {
    return this.paths.length;
  }

  get gain() {
    let gain = 0;
    for (let p of this.paths) {
      gain += p.gain();
    }
    return gain;
  }

  split(pathIndex, pointIndex) {
    let pnew = Object.freeze(this.paths[pathIndex].split(pointIndex));
    this.paths.splice(pathIndex + 1, 0, pnew);
  }

  indexOf(path) {
    return this.paths.indexOf(path) + 1;
  }

  serialize() {
    let res = '<?xml version="1.0" encoding="UTF-8"?>';
    res +=
      '<gpx creator="GpxEd" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.topografix.com/GPX/1/1 http://www.topografix.com/GPX/1/1/gpx.xsd http://www.garmin.com/xmlschemas/GpxExtensions/v3 http://www.garmin.com/xmlschemas/GpxExtensionsv3.xsd http://www.garmin.com/xmlschemas/TrackPointExtension/v1 http://www.garmin.com/xmlschemas/TrackPointExtensionv1.xsd" version="1.1" xmlns="http://www.topografix.com/GPX/1/1" xmlns:gpxtpx="http://www.garmin.com/xmlschemas/TrackPointExtension/v1" xmlns:gpxx="http://www.garmin.com/xmlschemas/GpxExtensions/v3">';

    for (let w of this.waypoints) {
      res += `<wpt lat="${w.lat}" lon="${w.lng}">`;
      let type = w.type;
      if (type == null) {
        type = "GENERIC";
      }
      res += `<name>${w.name}</name><desc>${w.description}</desc><type>${type}</type></wpt>`;
    }
    for (let p of this.paths) {
      res +=
        "<trk>" +
        (p.name ? `  <name>${p.name}</name>` : "") +
        "  <type>9</type>";
      res += `<gpxx:TrackExtension><gpxx:DisplayColor>${this.color}</gpxx:DisplayColor></gpxx:TrackExtension>`;
      res += p.serialize();
      res += "</trk>";
    }

    return res + "</gpx>";
  }

  load(content) {
    let options = {
      attributeNamePrefix: "@_",
      // attrNodeName: "attr", //default is 'false'
      textNodeName: "#text",
      ignoreAttributes: false,
      ignoreNameSpace: true,
      allowBooleanAttributes: false,
      parseNodeValue: true,
      parseAttributeValue: true,
      trimValues: true,
      cdataTagName: "__cdata", //default is 'false'
      cdataPositionChar: "\\c",
      parseTrueNumberOnly: false,
      arrayMode: true, //"strict"
      // eslint-disable-next-line no-unused-vars
      attrValueProcessor: (val, attrName) =>
        he.decode(val, { isAttributeValue: true }), //default is a=>a
      // eslint-disable-next-line no-unused-vars
      tagValueProcessor: (val, tagName) => he.decode(val), //default is a=>a
      stopNodes: ["parse-me-as-string"],
    };
    let gpx = parser.parse(content, options);
    for (let wpt of gpx["gpx"][0]["wpt"] || []) {
      let wp = new LatLng(wpt["@_lat"], wpt["@_lon"]);
      wp.name = wpt["name"] || "";
      wp.description = wpt["desc"] || "";
      wp.type = wpt["type"] || "GENERIC";
      this.waypoints.push(wp);
    }
    for (let trk of gpx["gpx"][0]["trk"] || []) {
      for (let trkx of trk["TrackExtension"] || []) {
        if (trkx["DisplayColor"]) {
          this.color = trkx["DisplayColor"];
        }
      }
      let points = [];
      for (let trkseg of trk["trkseg"] || []) {
        for (let trkpt of trkseg["trkpt"]) {
          let pt = null;
          if (trkpt["ele"]) {
            pt = new LatLng(trkpt["@_lat"], trkpt["@_lon"], trkpt["ele"]);
          } else {
            pt = new LatLng(trkpt["@_lat"], trkpt["@_lon"]);
          }
          if (trkpt["time"]) {
            pt.ts = new Date(trkpt["time"]).getTime() / 1000;
          }
          points.push(pt);
        }
      }
      this.paths.push(
        Object.freeze(
          new Path(this, trk["name"], points, this.paths.length + 1)
        )
      );
    }
  }

  static loadFromFile(file, content) {
    let gpxf = new GpxFile({ file: file });
    gpxf.load(content);
    return gpxf;
  }
}

export class PathList {
  constructor() {
    this.files = [];
    this.center = null;
    this.bounds = 0;
  }

  nearest(point) {
    let best = null;
    for (let file of this.files) {
      if (file.opacity === 0) {
        continue;
      }
      for (let path of file.paths) {
        let ix = path.nearest(point);
        if (best === null || best.dist > ix.dist) {
          best = ix;
        }
      }
    }
    return best;
  }

  nearestFile(point) {
    let best = null;
    let bestFile = null;
    for (let file of this.files) {
      if (file.opacity === 0) {
        continue;
      }
      for (let path of file.paths) {
        let ix = path.nearest(point);
        if (best === null || best.dist > ix.dist) {
          best = ix;
          bestFile = file;
        }
      }
    }
    return bestFile;
  }

  findClosestShortest(points, point) {
    let closest = [];
    let best = null;
    let bpath = null;

    for (let file of this.files) {
      if (file.opacity === 0) {
        continue;
      }
      for (let path of file.paths) {
        let ix = path.nearest(point);
        if (best === null || best.dist > ix.dist) {
          best = ix;
          bpath = path;
        }
      }
    }
    if (best === null) {
      return null;
    }
    let cl = bpath.findClosestShortest(points, best.minIx);
    closest = closest.concat(cl);

    closest.sort(function (a, b) {
      if (a.minIndex === -1) {
        return 1;
      }
      if (b.minIndex === -1) {
        return -1;
      }
      if (Math.abs(a.minDist - b.minDist) < 5) {
        return a.distOfMin - b.distOfMin;
      }
      return a.minDist - b.minDist;
    });
    if (closest.length > 0 && closest[0].minDist < 200) {
      return closest[0];
    } else {
      return null;
    }
  }

  load() {
    let meta = localStorage.getItem("metadatas");
    if (meta) {
      let metadatas = JSON.parse(meta);
      for (let md of metadatas) {
        let content = localStorage.getItem(md.handle);
        let gpx = new GpxFile(md);
        gpx.load(LZString.decompress(content));
        this.files.push(gpx);
      }
    }
    let options = localStorage.getItem("options");
    if (options) {
      let opt = JSON.parse(options);
      if (opt.ne) {
        this.bounds = latLngBounds(opt.ne, opt.sw);
      }
    }
  }

  save(omitContent, bounds) {
    let metas = [];
    for (let f of this.files) {
      let met = f.metadata();
      metas.push(met);
      if (!omitContent) {
        localStorage.setItem(met.handle, LZString.compress(f.serialize()));
      }
    }
    localStorage.setItem("metadatas", JSON.stringify(metas));
    if (bounds) {
      let options = { ne: bounds.getNorthEast(), sw: bounds.getSouthWest() };
      localStorage.setItem("options", JSON.stringify(options));
    }
  }

  remove(entries) {
    for (let file of entries) {
      localStorage.removeItem(file.handle);
      for (let index = 0; index < this.files.length; ++index) {
        if (this.files[index].file === file.file) {
          this.files.splice(index, 1);
          break;
        }
      }
    }
    this.save(true);
  }
}
